module.exports = __webpack_public_path__ + "img/ld_7@2x.4fd360b2.png";